import { render, staticRenderFns } from "./NotificationDropdownMessage.vue?vue&type=template&id=1ad3f979"
import script from "./NotificationDropdownMessage.vue?vue&type=script&lang=js"
export * from "./NotificationDropdownMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports